import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '../../components/shared.module';
import { LoginComponent } from './login.component';
import { LangComponentsModule } from '@digilize/shared/feature/modules/i18n/src';

const routes: Routes = [{ path: '', component: LoginComponent }];

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes), LangComponentsModule],
  exports: [LoginComponent],
})
export class LoginModule {}
